import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import styled from 'styled-components'

export function NewsletterCaptcha({ onTokenChange, ...props }) {
    return (
        <NewsletterCaptchaRoot {...props}>
            <ReCAPTCHA
                sitekey="6Lf1KHQUAAAAAFNKEX1hdSWCS3mRMv4FlFaNslaD"
                onChange={onTokenChange}
            />
        </NewsletterCaptchaRoot>
    )
}

const NewsletterCaptchaRoot = styled.div`
    height: 4.625rem;
`
